import { render, staticRenderFns } from "./globalTimer.vue?vue&type=template&id=45703751&scoped=true"
import script from "./globalTimer.vue?vue&type=script&lang=js"
export * from "./globalTimer.vue?vue&type=script&lang=js"
import style0 from "./globalTimer.vue?vue&type=style&index=0&id=45703751&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45703751",
  null
  
)

export default component.exports